import React, { useEffect, useState } from 'react';
import Hero from '../common/Hero';
import Footer from '../common/Footer';
import { initAnimations } from '../../utils/animations';
import Event1 from '../../assets/images/events-1.jpg'
import Event2 from '../../assets/images/events-2.jpg'
import Event3 from '../../assets/images/events-3.jpg'
const Events = () => {
  useEffect(() => {
    initAnimations();
  }, []);

  const breadcrumbs = [
    { text: 'Home', link: '/' },
    { text: 'Events' }
  ];
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch('https://backend.harveymasjid.com/api/event/getAllEvent', {
          method: 'GET',
          headers: {
            'Authorization': 'Basic ' + btoa(process.env.REACT_APP_NAME + ':' + process.env.REACT_APP_PASS),
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch events');
        }

        const data = await response.json();
        if (data.status === 1) {
          setEvents(data.events);
        } else {
          throw new Error(data.msg || 'Failed to retrieve events');
        }
      } catch (err) {
        setError(err.message);
        // Fallback to default events if API fails
        setEvents([
          {
            _id: "1",
            title: "Ramadan Preparation Workshop",
            description: "Join us for an informative session on how to maximize your Ramadan experience. Learn about spiritual preparation, healthy fasting practices, and making the most of the blessed month. Open to all community members.",
            date: "2024-03-15T18:30:00.000Z"
          },
          {
            _id: "2",
            title: "Youth Leadership Retreat",
            description: "A weekend program for Muslim youth ages 13-18 focusing on developing leadership skills, Islamic identity, and community service. Includes workshops, team-building activities, and outdoor recreation.",
            date: "2024-03-22T10:00:00.000Z"
          },
          {
            _id: "3",
            title: "Islamic Finance Seminar",
            description: "Learn about Islamic principles of finance, halal investing, and debt-free living from renowned Islamic finance experts. This event is particularly valuable for young professionals and families.",
            date: "2024-04-05T19:00:00.000Z"
          }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  // Default images array to cycle through if no images from API
  const eventImages = [Event1, Event2, Event3];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    const options = { weekday: 'short', hour: '2-digit', minute: '2-digit' };
    return date.toLocaleTimeString('en-US', options).replace(',', '');
  };

  if (loading) {
    return <div className="container-fluid event py-5">
      <div className="container py-5 text-center">Loading events...</div>
    </div>;
  }

  if (error) {
    console.error(error);
  }



  return (
    <>
      <Hero
        title="Events"
        breadcrumbs={breadcrumbs}
      />

      {/* <div className="container-fluid event py-5">
        <div className="container py-5">
          <h1 className="display-3 mb-5 wow fadeIn" data-wow-delay="0.1s">
            Upcoming <span className="text-primary">Events</span>
          </h1>
          <div className="row g-4 event-item wow fadeIn" data-wow-delay="0.1s">
            <div className="col-3 col-lg-2 pe-0">
              <div className="text-center border-bottom border-dark py-3 px-2">
                <h6>15 Mar 2024</h6>
                <p className="mb-0">Fri 6:30 PM</p>
              </div>
            </div>
            <div className="col-9 col-lg-6 border-start border-dark pb-5">
              <div className="ms-3">
                <h4 className="mb-3">Ramadan Preparation Workshop</h4>
                <p className="mb-4">
                  Join us for an informative session on how to maximize your Ramadan experience.
                  Learn about spiritual preparation, healthy fasting practices, and making the
                  most of the blessed month. Open to all community members.
                </p>
                <a href="https://play.google.com/store/apps/details?id=com.wasuan8.Harveymasjid" className="btn btn-primary px-3">Register Now</a>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="overflow-hidden mb-5">
                <img src={Event1} className="img-fluid w-100" alt="Ramadan Preparation" />
              </div>
            </div>
          </div>
          <div className="row g-4 event-item wow fadeIn" data-wow-delay="0.3s">
            <div className="col-3 col-lg-2 pe-0">
              <div className="text-center border-bottom border-dark py-3 px-2">
                <h6>22 Mar 2024</h6>
                <p className="mb-0">Sat 10:00 AM</p>
              </div>
            </div>
            <div className="col-9 col-lg-6 border-start border-dark pb-5">
              <div className="ms-3">
                <h4 className="mb-3">Youth Leadership Retreat</h4>
                <p className="mb-4">
                  A weekend program for Muslim youth ages 13-18 focusing on developing leadership
                  skills, Islamic identity, and community service. Includes workshops, team-building
                  activities, and outdoor recreation.
                </p>
                <a href="https://play.google.com/store/apps/details?id=com.wasuan8.Harveymasjid" className="btn btn-primary px-3">Join Now</a>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="overflow-hidden mb-5">
                <img src={Event2} className="img-fluid w-100" alt="Youth Retreat" />
              </div>
            </div>
          </div>
          <div className="row g-4 event-item wow fadeIn" data-wow-delay="0.5s">
            <div className="col-3 col-lg-2 pe-0">
              <div className="text-center border-bottom border-dark py-3 px-2">
                <h6>05 Apr 2024</h6>
                <p className="mb-0">Fri 7:00 PM</p>
              </div>
            </div>
            <div className="col-9 col-lg-6 border-start border-dark pb-5">
              <div className="ms-3">
                <h4 className="mb-3">Islamic Finance Seminar</h4>
                <p className="mb-4">
                  Learn about Islamic principles of finance, halal investing, and debt-free living
                  from renowned Islamic finance experts. This event is particularly valuable for
                  young professionals and families.
                </p>
                <a href="https://play.google.com/store/apps/details?id=com.wasuan8.Harveymasjid" className="btn btn-primary px-3">Register Now</a>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="overflow-hidden mb-5">
                <img src={Event3} className="img-fluid w-100" alt="Islamic Finance" />
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="container-fluid event py-5">
        <div className="container py-5">
          <h1 className="display-3 mb-5 wow fadeIn" data-wow-delay="0.1s">
            Upcoming <span className="text-primary">Events</span>
          </h1>

          {events.length === 0 ? (
            <p>No upcoming events found.</p>
          ) : (
            events.map((event, index) => (
              <div key={event._id} className="row g-4 event-item wow fadeIn" data-wow-delay={`${0.1 + (index * 0.2)}s`}>
                <div className="col-3 col-lg-2 pe-0">
                  <div className="text-center border-bottom border-dark py-3 px-2">
                    <h6>{formatDate(event.date)}</h6>
                    <p className="mb-0">{formatTime(event.time || event.date)}</p>
                  </div>
                </div>
                <div className="col-9 col-lg-6 border-start border-dark pb-5">
                  <div className="ms-3">
                    <h4 className="mb-3">{event.title}</h4>
                    <p className="mb-4">{event.description}</p>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.wasuan8.Harveymasjid"
                      className="btn btn-primary px-3"
                    >
                      Register Now
                    </a>
                  </div>
                </div>
                <div className="col-12 col-lg-4">
                  <div className="overflow-hidden mb-5">
                    <img
                      src={eventImages[index % eventImages.length]}
                      className="img-fluid w-100"
                      alt={event.title}
                    />
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Events;